/**
 * API Configuration Utility
 * Provides centralized API URL construction with diagnostic logging
 * to help identify environment variable issues
 * 
 * iOS Fix: Added comprehensive iOS diagnostics
 */

// Detect iOS devices
const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream;

export const getApiUrl = () => {
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  
  // DIAGNOSTIC LOGGING (remove after issue is resolved)
  console.group('🔍 API Configuration Diagnostic');
  console.log('📱 Platform:', isIOS ? 'iOS' : 'Other');
  console.log('📍 Environment:', process.env.NODE_ENV);
  console.log('🌍 Hostname:', window.location.hostname);
  console.log('🔗 Full URL:', window.location.href);
  console.log('🔑 REACT_APP_BACKEND_URL:', baseUrl);
  console.log('🛠️ Constructed API:', `${baseUrl}/api`);
  console.log('✅ Expected:', 'https://timetable-dedup.preview.emergentagent.com/api OR https://buddy.gdiot.in/api');
  
  // iOS-specific checks
  if (isIOS) {
    console.log('📱 iOS Detection:', {
      userAgent: navigator.userAgent,
      cookieEnabled: navigator.cookieEnabled,
      hasCookies: document.cookie.length > 0,
      currentCookies: document.cookie || '(none)'
    });
  }
  
  console.groupEnd();
  
  // Preview environment safety check
  // If we detect the "1" issue, we can implement a workaround here
  if (baseUrl && (baseUrl.endsWith('1') || baseUrl.endsWith('/api1'))) {
    console.warn('⚠️ DETECTED TRAILING "1" IN BACKEND URL!');
    console.warn('Current value:', baseUrl);
    console.warn('This will cause 502 errors. Needs immediate fix in environment config.');
  }
  
  return `${baseUrl}/api`;
};

export default getApiUrl;
